import type { Theme } from "@mui/material"
import { createGlobalNavigationItemTheme } from "./components/GlobalNavigationItem"
import { createCompilationsListItemTheme } from "./components/CompilationsListItem"
import { createArticleListGridTheme } from "./components/ArticleListContainer"
import { createCalcInputButtonTheme } from "./components/CustomButton"
import { CustomThemeCreator } from "../../types"
import { createCustomExternalCatalogWidgetIconTheme } from "./components/CustomExternalCatalogWidgetIcon"
import { createSimpleWidgetCardTheme } from "./components/SimpleWidgetCard"
import { createCustomTextFieldTheme } from "./components/TextField"

export const createTheme: CustomThemeCreator = (theme: Theme) => ({
    GlobalNavigationItem: createGlobalNavigationItemTheme(theme),
    CompilationsListItem: createCompilationsListItemTheme(theme),
    ArticleListGrid: createArticleListGridTheme(theme),
    CalcInputButton: createCalcInputButtonTheme(theme),
    // BasketButton: createBasketButtonTheme(theme),
    CustomExternalCatalogWidgetIcon: createCustomExternalCatalogWidgetIconTheme(theme),
    SimpleWidgetCard: createSimpleWidgetCardTheme(theme),
    BasketButton: {
        styleOverrides: {
            root: {
                background: "superred",
            },
        },
    },
    CustomTextField: createCustomTextFieldTheme(theme),
})
